import { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import isEqual from 'lodash/isEqual'
import isEmpty from 'lodash/isEmpty'

import { getScripts } from 'selectors/appStatusSelectors'

export function usePrevious(value) {
  const ref = useRef()

  useEffect(() => {
    ref.current = value
  })

  return ref.current
}

export const setAttributes = (dest, source) => {
  let { attributes: atts } = source,
    att

  for (let i = 0; i < atts.length; i++) {
    att = atts[i]

    let { nodeName, nodeValue } = att
    dest.setAttribute(nodeName, nodeValue)
  }
}

export const createElementFromHTML = htmlString => {
  var template = document.createElement('template')
  template.innerHTML = htmlString.trim()

  return template.content.firstChild
}

export const useRawScripts = scripts => {
  let prevScripts = usePrevious(scripts)

  useEffect(() => {
    if (isEmpty(scripts) || isEqual(scripts, prevScripts)) return

    scripts.forEach(script => {
      try {
        if (!document.getElementById(script.name)) {
          const scriptWrapper = document.createElement('script'),
            scriptBody = createElementFromHTML(script.body)

          setAttributes(scriptWrapper, scriptBody)

          scriptWrapper.id = script.name.replace(/\s/g, '')
          scriptWrapper.innerHTML = scriptBody.innerHTML

          document.body.appendChild(scriptWrapper)
        }
      } catch (e) {
        console.error('Problem loading custom script:', script.name)
      }
    })
  }, [scripts, prevScripts])
}

export function CustomScripts({ scripts }) {
  useRawScripts(scripts)

  return null
}

function mapStateToProps(state, op) {
  return {
    ...op,
    scripts: getScripts(state),
  }
}

export default connect(mapStateToProps)(CustomScripts)
